import find from 'lodash/find';

// opened brackets, type {[keyOfObject: string]?: true | {...}}
export const TableViewerOpenedTabsState = Symbol('TableViewerOpenedTabsState');

// true or false
export const TableViewerShowAllByDefault = Symbol('TableViewerShowAllByDefault');

export const isObject = (value) => !Array.isArray(value) && value !== null && typeof value === 'object';

export const isArrayOfObjects = (data) => Array.isArray(data) && find(data, (value) => typeof value === 'object');
